module.exports = __webpack_public_path__ + "img/julius-baer.cb58bffa.png";